/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/TiffGenerator.yaml

import { ScanbotTiffGeneratorImpl } from './impl';
import type { ImageInput } from './types/base/customTypes';
import type { TiffGeneratorParameters } from './types/core/tiff_generation/TiffTypes';

/**
 * Entry point for all TIFF generation features.
 */
export const ScanbotTiffGenerator = {
  /**
   * Creates a TIFF from the provided images with the specified configuration.
   * @param {ImageInput[]} params.images - The list of images to be used for creating the TIFF.
   * @param {TiffGeneratorParameters} params.tiffGeneratorParameters - The configuration parameters for TIFF generation.
   * @returns {Promise<string>} - The file uri pointing to the generated TIFF file.
   */
  async generateFromImages(params: {
    images: ImageInput[];
    tiffGeneratorParameters: TiffGeneratorParameters;
  }): Promise<string> {
    return ScanbotTiffGeneratorImpl.generateFromImages(params);
  },
  /**
   * Creates a TIFF from the provided images with the specified configuration.
   * @param {string} params.documentUuid - The Uuid of the document to be used for creating the TIFF.
   * @param {TiffGeneratorParameters} params.tiffGeneratorParameters - The configuration parameters for TIFF generation.
   * @returns {Promise<string>} - The file uri pointing to the generated TIFF file.
   */
  async generateFromDocument(params: {
    documentUuid: string;
    tiffGeneratorParameters: TiffGeneratorParameters;
  }): Promise<string> {
    return ScanbotTiffGeneratorImpl.generateFromDocument(params);
  },
};
